import { GetProjectScheduledEmails } from '@/connection/emails/get-project-scheduled-emails';
import { serializeError } from '@/store/utils/serialize-error';
import { ProjectStateReducerCreator } from '../types';

const getProjectScheduledEmailsReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ projectUuid }: { projectUuid: string }, { rejectWithValue }) => {
      try {
        const result = await GetProjectScheduledEmails({ projectUuid });
        if ('error' in result) {
          console.error('getProjectScheduledEmails error', result.error);
          return rejectWithValue(serializeError(result.error));
        }
        return result;
      } catch (error) {
        console.error('Error fetching scheduled emails:', error);
        return rejectWithValue('Error fetching scheduled emails');
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.scheduledEmails = action.payload;
        }
        state.loadingScheduledEmails = false;
      },
      pending: (state) => {
        state.loadingScheduledEmails = true;
      },
      rejected: (state, action) => {
        console.error('Error loading scheduled emails:', action.error);
        state.loadingScheduledEmails = false;
      },
    }
  );
};

export default getProjectScheduledEmailsReducer;
